import global from "@/locales/bg-BG/global";
import error403 from "@/locales/bg-BG/errors/403";
import error404 from "@/locales/bg-BG/errors/404";
import error500 from "@/locales/bg-BG/errors/500";
import error503 from "@/locales/bg-BG/errors/503";
import error504 from "@/locales/bg-BG/errors/504";
import maintenance from "@/locales/bg-BG/auth/maintenance";
import toast from "@/locales/bg-BG/toast/toast";
import login from "@/locales/bg-BG/auth/login";
import onboarding from "@/locales/bg-BG/auth/onboarding";
import loginPageSteps from "@/locales/bg-BG/loginPageSteps";
import dashboard from "@/locales/bg-BG/dashboard/dashboard";
import account from "@/locales/bg-BG/account/account";
import mailbox from "@/locales/bg-BG/account/mailbox";
import bankstatement from "@/locales/bg-BG/account/bankstatement";
import myApps from "@/locales/bg-BG/my-apps/myApps";
import about from "@/locales/bg-BG/about/about";
import contactService from "@/locales/bg-BG/about/contactService";
import salesPromotions from "@/locales/bg-BG/sales/promotions";
import brochures from "@/locales/bg-BG/sales/brochures";
import shop from "@/locales/bg-BG/shop/data";
import priceList from "@/locales/bg-BG/shop/priceList";
import staff from "@/locales/bg-BG/dashboard/staff";
import promotions from "@/locales/bg-BG/promotions";
import points from "@/locales/bg-BG/points";
import trainings from "@/locales/bg-BG/trainings/trainings";
import vouchers from "@/locales/bg-BG/vouchers/vouchers";
import media from "@/locales/bg-BG/media/index";
import product from "@/locales/bg-BG/product/index";
import message from "@/locales/bg-BG/message/index";
import commitmentLetter from "@/locales/bg-BG/account/commitmentLetter";
import multiplicator from "@/locales/bg-BG/multiplicator";
import widgets from "@/locales/bg-BG/widgets/widgets";
import consents from "@/locales/bg-BG/consents/consents";
import investment from "@/locales/bg-BG/investment/data";
import kickback from "@/locales/bg-BG/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Снимки на продукти",
    BDriveLinkText: "Връзка към портала за ПРОДУКТОВИ ИЗОБРАЖЕНИЯ",
  },
}

export default {
  locale: "bg-BG",
  messages,
};
